<template>
  <v-autocomplete
    :items="country_areas"
    item-text="name"
    item-value="id"
    @change="handleSelect"
    :loading="loading"
    :value="country_area"
    v-bind="$props"
    return-object
    :disabled="loading"
    :color="color"
    :outlined="outlined"
    :dense="dense"
  ></v-autocomplete>
</template>

<script>
import { getCountryAreas } from "../../services/locals";
import { getCountryAreas as getPublicCountryAreas } from "../../services/customer_inbound";

export default {
  name: "select-country-area",
  props: {
    country_area: Object,
    label: String,
    clearable: Boolean,
    "error-messages": Array,
    name: String,
    autofocus: Boolean,
    autocomplete: String,
    color: {
      type: String,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    publicApi: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "country_area",
    event: "change",
  },
  data: () => ({
    country_areas: [],
    loading: false,
  }),
  methods: {
    async getCountryAreas() {
      this.loading = true;
      const fetcher = this.publicApi ? getPublicCountryAreas : getCountryAreas;
      this.country_areas = await fetcher("pt");
      this.loading = false;
    },
    handleSelect(value) {
      this.$emit("change", value);
    },
  },
  created() {
    this.getCountryAreas();
  },
};
</script>
